import { render, staticRenderFns } from "./formAssociationForm.vue?vue&type=template&id=6aff172c&scoped=true"
import script from "./formAssociationForm.vue?vue&type=script&lang=js"
export * from "./formAssociationForm.vue?vue&type=script&lang=js"
import style0 from "./formAssociationForm.vue?vue&type=style&index=0&id=6aff172c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aff172c",
  null
  
)

export default component.exports